var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.32.681a.626.626 0 00-.657-.144l-13.75 5a.625.625 0 000 1.169L6.282 8.85l3.962-3.975.882.881-3.982 3.981 2.15 5.369a.625.625 0 00.582.394.625.625 0 00.575-.413l5-13.75a.624.624 0 00-.132-.656z",
    fill: "#fff"
  })));
}

export default SvgSendMobileIcon;